import { Dialog } from "@mui/material";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { useEffect, useState } from "react";
import { toggleCart } from "store/slices/main.slice";
import CartView from "./Cart";
import Details from "./Details";
import OrderType from "./OrderType";
import PaymentPage from "./PaymentPage";
import CheckoutView from "./Checkout";

type Props = {
  setShowPopup: (v: boolean) => void;
  setOrderTotal: (v: number) => void;
};

const CartDialog = (props: Props) => {
  const dispatch = useAppDispatch();
  const { settings } = useAppSelector(({ main }) => main);

  const [stage, setStage] = useState(
    settings.ApplyTakeOutDeliveryPrice !== 0 ? "CART" : "ORDERTYPE"
  );

  const showCart = useAppSelector(({ main }) => main.showCart);

  // === ADDED BY SAMPATH – 2026-01-14 ===
  // Center dialog must open ONLY after Place Order (DETAILS / CHECKOUT / PAYMENT stages)
  const [openCenterDialog, setOpenCenterDialog] = useState(false);

  useEffect(() => {
    const shouldOpen =
      stage === "DETAILS" || stage === "CHECKOUT" || stage === "PAYMENT" || stage === "ORDERTYPE";
    setOpenCenterDialog(shouldOpen);
  }, [stage]);
  // === END SAMPATH ===

  useEffect(() => {
    setStage(settings.ApplyTakeOutDeliveryPrice !== 0 ? "CART" : "ORDERTYPE");
  }, [settings]);

  // === ADDED BY SAMPATH – 2026-01-14 ===
  // IMPORTANT:
  // - Right drawer uses showCart (toggleCart)
  // - Center dialog must NOT open when stage is CART
  // So: we keep rendering CartView (drawer) always, but Dialog opens only for non-CART stages.
  // === END SAMPATH ===

  return (
    <>
      {/* === ADDED BY SAMPATH – 2026-01-14 === */}
      {/* Right-side Cart Drawer (NO center dialog) */}
      {showCart && stage === "CART" && <CartView setStage={setStage} />}
      {/* === END SAMPATH === */}

      <Dialog
        onClose={() => {
          // === ADDED BY SAMPATH – 2026-01-14 ===
          // Closing center dialog should return to CART stage (drawer can be opened again by cart icon)
          setOpenCenterDialog(false);
          setStage("CART");
          // === END SAMPATH ===
        }}
        // === ADDED BY SAMPATH – 2026-01-14 ===
        // ONLY open center dialog after Place Order flow starts (not when cart icon clicked)
        open={openCenterDialog}
        // === END SAMPATH ===
        maxWidth={false}
        fullScreen
        PaperProps={{
          sx: {
            width: "100vw",
            maxWidth: "100vw",
            height: "100dvh",
            maxHeight: "100dvh",
            margin: 0,
            borderRadius: 0,
            overflow: "hidden",
          },
        }}
      >
        <div className="w-full h-full min-h-0 flex flex-col">
          {stage === "ORDERTYPE" && <OrderType setStage={setStage} />}
          {/* === ADDED BY SAMPATH – 2026-01-14 === */}
          {/* CART stage is handled by the RIGHT drawer above (so don't render here) */}
          {/* === END SAMPATH === */}
          {stage === "DETAILS" && (
            <Details
              setStage={setStage}
              setShowPopup={props.setShowPopup}
              setOrderTotal={props.setOrderTotal}
            />
          )}
          {stage === "CHECKOUT" && (
            <CheckoutView
              setStage={setStage}
              setShowPopup={props.setShowPopup}
              setOrderTotal={props.setOrderTotal}
            />
          )}
          {stage === "PAYMENT" && (
            <PaymentPage
              setStage={setStage}
              setShowPopup={props.setShowPopup}
              setOrderTotal={props.setOrderTotal}
            />
          )}
        </div>
      </Dialog>
    </>
  );
};

export default CartDialog;
